import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/assistant`;
const http = axios.create({ baseURL: API, withCredentials: true });
const data = (p) => p.then((r) => r.data);

export const listChats = () => data(http.get("/sessions"));
export const getChat = (id) => data(http.get(`/sessions/${id}`));
export const deleteChat = (id) => data(http.delete(`/sessions/${id}`));
export const suggestStyle = (body) => data(http.post("/style", body, { timeout: 90_000 }));

/** Streams one assistant reply. onEvent gets {session_id,…} first, then {text} deltas, then {done}. */
export async function streamChat({ message, sessionId, projectId, songId, signal, onEvent }) {
  const res = await fetch(`${API}/chat`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ message, session_id: sessionId || null, project_id: projectId || null, song_id: songId || null }),
    signal,
  });
  if (!res.ok) {
    let detail = "";
    try { detail = (await res.json())?.detail || ""; } catch (e) { void e; }
    throw new Error(detail || `ChatGPT couldn't answer (${res.status})`);
  }
  const reader = res.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  for (;;) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const events = buffer.split("\n\n");
    buffer = events.pop() ?? "";
    for (const ev of events) {
      const line = ev.split("\n").find((l) => l.startsWith("data:"));
      if (!line) continue;
      let parsed;
      try { parsed = JSON.parse(line.slice(5).trim()); } catch (e) { void e; continue; }
      if (parsed.error) throw new Error(parsed.error);
      onEvent(parsed);
    }
  }
}
